import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAuthToken, useAuthUser } from './useAuth';
import { useMutation } from './useMutation';

interface useBrandArchiveProps {
  onSuccess: TypeAny;
  id: string;
}

export function useBrandArchive({ onSuccess, id }: useBrandArchiveProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();
  const user = useAuthUser();

  const { isLoading, mutate, error } = useMutation({
    mutationKey: 'brand-archive',
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${user?.team?.team_id}/brand/${id}/archive`,
        body: {
          brand_id: id,
          team_id: user?.team?.team_id
        },
        token
      }).then((response: Api.Brand | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutate,
    error
  };
}
